import MainLayout from "Layout/MainLayout";
import React from "react";
import { Navigate, useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { getUserNameFromReducer } from "Store/reducers/Auth/AuthSlice";

function PrivateRoute(props) {
  const { token } = props;
  const username = useSelector(getUserNameFromReducer);
  const { username: routeUsername } = useParams();
  
  // If not authenticated, redirect to login
  if (!token) {
    return <Navigate to={"/login"} />;
  }
  
  // If accessing a username route, verify ownership
  if (routeUsername && username && username !== routeUsername) {
    return <Navigate to={`/${username}`} />;
  }
  
  return <MainLayout>{props?.element}</MainLayout>;
}

export default PrivateRoute;
